import {ElementRef, HostListener, Directive} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[decimal]'
})


export class DecimalDirective {

  constructor(private el: ElementRef, public model: NgControl) {
  }

  @HostListener('input') onEvent() {
    let oldValue = this.el.nativeElement.value || '';
    let newValue = oldValue.replace(/\D/g, '');
    if (newValue != oldValue) {
      this.model.control.setValue(newValue);
    }
  }

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/directives/decimal.directive.ts